<template>
  <div class="page-container">
    <div id="searchArea">
      <el-form class="el-form-filter" :inline="true" :model="dataForm" @keyup.enter.native="getDataList(1)">
        <el-form-item>
          <el-input style="width: 500px" v-model="dataForm.keyword" :placeholder="kwPlaceHolder" class="input-with-select-lg">
            <el-select v-model="dataForm.kwType" slot="prepend" placeholder="Please Select">
              <el-option v-for="item in kwTypes" :key="item.value" :label="item.title" :value="item.value"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.payType" multiple clearable placeholder="Pay Type">
            <el-option v-for="item in payTypes" :key="item.value" :label="item.title" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.orderStatus" multiple clearable placeholder="Oder Status">
            <el-option v-for="item in orderStatusList" :key="item.value" :label="item.title" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.noCredit" placeholder="Select Credit Status Or Blank" class="wd180 controlLeft" @change="noCreditChange">
            <el-option label="Select Credit Status" :value="false"></el-option>
            <el-option label="Select Credit Blank" :value="true"></el-option>
          </el-select>
          <template v-if="dataForm.noCredit == false">
            <el-select v-model="dataForm.creditStatus" multiple clearable placeholder="Credit Status" class="wd300 controlRight">
              <el-option v-for="item in creditStatusList" :key="item.value" :label="item.title" :value="item.value"></el-option>
            </el-select>
          </template>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.orderType" multiple clearable placeholder="Order Type">
            <el-option v-for="item in orderTypeList" :key="item.value" :label="item.title" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.billingCurrency" clearable placeholder="Billing Currency">
            <el-option v-for="item in currencyList" :key="item.currency" :label="item.currency" :value="item.currency"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            value-format="timestamp"
            v-model="watchStartToEndMillisecondTimeRange"
            type="daterange"
            range-separator="~"
            start-placeholder="Start Time"
            end-placeholder="End Time"
            style="width: 384px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.supplierId" filterable clearable placeholder="Supplier">
            <el-option v-for="item in supplierList" :key="item.id" :label="item.companyName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" plain v-debounce @click="getDataList(1)">Search</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 批量操作 -->
    <div id="operationArea">
      <!-- 批量收款 -->
      <el-button
        v-if="isAuth('finance:financial')"
        type="primary"
        plain
        size="small"
        icon="el-icon-thumb"
        :disabled="dataListSelections.length <= 0"
        @click="handleRecepit"
        class="mb16"
      >
        Batch Confirm Recepit
      </el-button>
      <!-- 导出 excel -->
      <el-button
        v-if="isAuth('finance:financial')"
        type="primary"
        plain
        size="small"
        icon="el-icon-download"
        :loading="batchDownBtnLoading"
        @click="handleExportExcel"
        :disabled="dataListSelections.length <= 0"
        class="mb16"
      >
        Export Excel
      </el-button>
      <!-- 批量打印发票 -->
      <el-button
        v-if="isAuth('finance:financial') || isAuth('finance:printInvoices')"
        type="primary"
        plain
        size="small"
        icon="el-icon-thumb"
        @click="handleBatchPrintInvoices"
        :disabled="dataListSelections.length <= 0"
        class="mb16"
      >
        Batch Print Invoices
      </el-button>
    </div>
    <div>
      <el-table
        max-height="600"
        :data="dataList"
        v-loading="dataListLoading"
        @selection-change="selectionChangeHandle"
        style="width: 100%"
        @sort-change="tableSortChange"
        :default-sort="{ prop: 'createTime', order: 'descending' }"
      >
        <el-table-column type="selection" align="center" width="40"></el-table-column>
        <el-table-column fixed="left" prop="businessNo" align="center" width="140" label="Transaction No."></el-table-column>
        <el-table-column align="center" label="Supplier" width="150" fixed="left">
          <template slot-scope="scope">
            <p>{{ scope.row.supplier?.abbr || "" }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="orderNo" align="center" width="140" label="Order No."></el-table-column>
        <el-table-column prop="description" align="center" min-width="250" label="Description"></el-table-column>
        <el-table-column prop="clientCode" align="center" label="Client Code" width="110" />
        <el-table-column prop="billingParty" align="center" label="Billing Party" min-width="200" />
        <el-table-column align="center" width="134" label="Price (Excl. Tax)">
          <template slot-scope="scope">
            <p>{{ currencyAndAmountFormat(scope.row.billingCurrency, scope.row.amount) }}</p>
            <p>{{ symbolAndAmountFormat("¥", scope.row.amountCny) }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="billingCurrency" align="center" label="billing Currency" width="140" />
        <el-table-column prop="status" align="center" width="120" label="Order Status">
          <template slot-scope="scope">
            <p>{{ orderStatusFormat(scope.row.status) }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="creditStatus" align="center" width="120" label="Credit Status">
          <template slot-scope="scope">
            <p>{{ creditStatusFormat(scope.row.creditStatus) }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" align="center" width="130" label="Create Time" sortable="custom"></el-table-column>
        <el-table-column prop="paymentDueTime" align="center" width="180" label="Payment Due Date" sortable="custom"></el-table-column>
        <el-table-column prop="finishTime" align="center" width="130" label="Finish Time" sortable="custom"></el-table-column>
        <el-table-column prop="payType" align="center" width="130" label="Pay Type">
          <template slot-scope="scope">
            <p>{{ payTypesFormat(scope.row.payType) }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="orderType" align="center" width="140" label="Order Type">
          <template slot-scope="scope">
            <p>{{ orderTypeFormat(scope.row.orderType) }}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" width="260" label="Personnel">
          <template slot-scope="scope">
            <div v-if="scope.row.companyApplyment">
              <p v-if="scope.row.companyApplyment.coordinator">
                Coordinator: {{ scope.row.companyApplyment.coordinator.nickname || scope.row.companyApplyment.coordinator.username }}
              </p>
              <p v-if="scope.row.companyApplyment.checker">
                Checker: {{ scope.row.companyApplyment.checker.nickname || scope.row.companyApplyment.checker.username }}
              </p>
              <p v-if="scope.row.companyApplyment.auditor">
                Reviewer: {{ scope.row.companyApplyment.auditor.nickname || scope.row.companyApplyment.auditor.username }}
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" align="center" label="Action" width="110">
          <template slot-scope="scope">
            <el-button @click="detailHandler(scope.row.id)" type="text" class="fwb">Detail</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination
        :current="current"
        :pageSize="pageSize"
        :totalCount="totalCount"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
      ></pagination>
    </div>

    <!-- 批量收款 - 弹框 -->
    <batch-confirm-receipt ref="batchConfirmReceiptRef" @refreshDataList="getDataList()"></batch-confirm-receipt>
  </div>
</template>

<script>
import { downloadFile } from "@/utils";
import Pagination from "@/components/Pagination";
import BatchConfirmReceipt from "./modal/BatchConfirmReceipt.vue";
import searchMixin from "@/mixins/searchMixin";
import tableMixin from "@/mixins/tableMixin";
import formatterMixin from "@/mixins/formatterMixin";
import paginationMixin from "@/mixins/paginationMixin.js";
import { mapState } from "vuex";
export default {
  mixins: [searchMixin, paginationMixin, tableMixin, formatterMixin],
  components: {
    BatchConfirmReceipt,
    Pagination,
  },
  data() {
    return {
      dataList: [],
      dataListLoading: false,
      dataListSelections: [],
      kwTypes: [
        {
          title: "Transaction No.",
          value: "businessNo",
          placeholder: "Transaction No.",
        },
        {
          title: "Order No.",
          value: "orderNo",
          placeholder: "Order No.",
        },
        {
          title: "Billing Party",
          value: "billingParty",
          placeholder: "Billing Party",
        },
        {
          title: "Price",
          value: "amount",
          placeholder: "Price",
        },
        {
          title: "Description",
          value: "description",
          placeholder: "Description",
        },
      ],
      watchStartToEndMillisecondTimeRange: null,
      dataForm: {
        payType: "",
        orderStatus: "",
        noCredit: false,
        creditStatus: "",
        startTime: null,
        endTime: null,
        orderType: null,
        billingCurrency: null,
        kwType: "businessNo",
        keyword: "",
        supplierId: "",
        "orders[0].asc": false,
        "orders[0].column": "id",
      },
      batchDownBtnLoading: false, // 批量导出
      supplierList: [],
    };
  },
  computed: {
    ...mapState("constant", ["orderStatusList", "payTypes", "orderTypeList", "creditStatusList"]),
    ...mapState("currency", ["currencyList"]),
  },
  methods: {
    // 获取供应商列表
    getSupplierList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/supplier")
          .then(res => {
            this.supplierList = res.data || [];
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    // noCredit下拉框 - change
    noCreditChange() {
      if (this.dataForm.noCredit) {
        this.$set(this.dataForm, "creditStatus", "");
      }
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val;
    },
    //批量收款
    handleRecepit() {
      let orderIds = [];
      this.dataListSelections.forEach(item => {
        if (item.status && (item.status === "UNPAID" || item.status === "PARTLY_PAID")) {
          orderIds.push(item.id);
        }
      });
      if (orderIds.length == 0) {
        this.$message.warning("You can't operate it until the filter of Order Status is 'Unpaid' or 'Partly Paid'.");
        return false;
      }
      this.$refs.batchConfirmReceiptRef.init(orderIds);
    },
    //导出 Excel
    handleExportExcel() {
      const ids = this.dataListSelections.map(item => item.id);
      this.batchDownBtnLoading = true;
      this.$http
        .get("/admin/orderManage/export", {
          params: { ids },
          responseType: "blob",
        })
        .then(res => {
          downloadFile(res);
        })
        .finally(() => {
          this.batchDownBtnLoading = false;
        });
    },
    // 批量打印发票
    handleBatchPrintInvoices() {
      const component = this.dataListSelections.map(item => item.id).join(",");
      const encodedComponent = encodeURIComponent(component);
      const newpage = `${process.env.VUE_APP_URL_INVOICE}/batchPrintInvoice?orderId=${encodedComponent}`;
      window.open(newpage, "_blank");
    },
    //数据请求
    async getDataList(current) {
      this.dataListLoading = true;
      if (current) {
        this.current = current;
      }
      const params = {
        current: this.current,
        size: this.pageSize,
        // "orders[0].asc": false,
        // "orders[0].column": "id",
        ...this.dataForm,
        [this.dataForm.kwType]: this.dataForm.keyword,
      };
      const { code, data } = await this.$http.get("/admin/orderManage/paging", {
        params,
      });
      if (code === 200) {
        this.dataList = data.records;
        this.totalCount = data.total;
      } else {
        this.dataList = [];
        this.totalCount = 0;
      }
      this.dataListLoading = false;
    },
    //详情
    detailHandler(id) {
      this.$router.push(`/finance/order/${id}`);
    },
  },
  activated() {
    this.getSupplierList();
    this.getDataList();
  },
};
</script>
<style lang="scss" scoped>
.controlLeft {
  ::v-deep input {
    // border-right: none;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  ::v-deep .el-input__inner:focus {
    border-color: #dcdfe6 !important;
  }

  ::v-deep .el-input__inner.is-focus {
    border-color: #dcdfe6 !important;
  }

  ::v-deep .el-input:focus {
    .el-input__inner {
      border-color: #dcdfe6 !important;
    }
  }

  ::v-deep .el-input.is-focus {
    .el-input__inner {
      border-color: #dcdfe6 !important;
    }
  }
}

.controlRight {
  border-left: none;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;

  ::v-deep input {
    border-left: none;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
</style>
